import preview from "../customer-area/virtualScroll/preview";

export default (hasMore, loading) => ({
    hasMore,
    loading,
    container: null,
    ...preview,

    init() {
        this.$nextTick(() => {
            this.prepare();
        });
    },

    prepare() {
        this.preview = this.$refs.preview;
        this.container = this.$refs.container;

        this.movePreviewToOutside();
    },

    loadMore({ target }) {
        if(target.scrollHeight <= target.clientHeight) {
            return;
        }

        const height = target.scrollHeight;
        const scroll = target.scrollTop + target.offsetHeight;

        if (this.hasMore && ((scroll * 1.05) >= (height * .5))) {
            this.$dispatch('load-more');
        }
    },
});
